// ES2019+ array/object basics
import 'core-js/es/array/flat';
import 'core-js/es/array/flat-map';
import 'core-js/es/object/from-entries';

// ES2020–2021
import 'core-js/es/promise/all-settled';
import 'core-js/es/promise/any';
import 'core-js/es/string/match-all';
import 'core-js/es/string/replace-all';

// ES2022
import 'core-js/es/array/at';
import 'core-js/es/object/has-own';
import 'core-js/es/typed-array/at';

// ES2023 "change by copy" + findLast*
import 'core-js/es/array/find-last';
import 'core-js/es/array/find-last-index';
import 'core-js/es/array/to-reversed';
import 'core-js/es/array/to-sorted';
import 'core-js/es/array/to-spliced';
import 'core-js/es/array/with';
import 'core-js/es/typed-array/find-last';
import 'core-js/es/typed-array/find-last-index';
import 'core-js/es/typed-array/to-reversed';
import 'core-js/es/typed-array/to-sorted';
import 'core-js/es/typed-array/with';

// ES2024 — absent on Safari < 17.4 and Chrome/Edge < 119. pdfjs-dist (pulled in
// by react-pdf) calls Promise.withResolvers unguarded, so without this the PDF
// surfaces throw on load for anyone below those versions.
//
// NOSONAR silences S7742, which reads browserslist to decide a polyfill is
// redundant. The repo declares no browserslist, so it judges against the default
// `last 2 versions` query; RUM says 48 events a week on Safari < 17.4. The wider
// fix is a real browserslist, which moves transpilation for the whole app.
import 'core-js/es/promise/with-resolvers'; // NOSONAR

// AbortSignal.any/.timeout — absent on Safari < 17.4 and Chrome/Edge < 116.
import { installAbortSignalPolyfill } from '@/utils/abortSignalPolyfill';

installAbortSignalPolyfill();
